import { authenticatedFetch } from '../../../api/request';

export default async function getLanguagesInProfile(doctorId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener los lenguajes del perfil.');
    return await authenticatedFetch(`/doctor-profile-management/languages-in-profile/${doctorId}`, onError);
}
